/**
 * Helper para download de arquivos via blob com bearer token.
 * Evita manipulação direta do DOM (appendChild/removeChild em document.body)
 * que conflita com a reconciliação do React e causa erro
 * "Failed to execute 'removeChild' on 'Node'".
 */
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Baixa um arquivo de um endpoint autenticado.
 * @param {string} path - caminho relativo à API (sem /api), ex: '/cotacoes/x/pdf'
 * @param {string} filename - nome do arquivo no download
 * @param {string} errorMsg - mensagem em caso de erro
 */
export async function downloadAuthed(path, filename, errorMsg = 'Erro ao baixar arquivo') {
  try {
    const token = localStorage.getItem('nautilus_token');
    const url = `${API}/api${path.startsWith('/') ? '' : '/'}${path}`;
    const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) throw new Error('falha');
    const blob = await r.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    link.style.display = 'none';
    // .click() funciona sem appendChild em todos os navegadores modernos.
    link.click();
    // Revoga depois do click event terminar (setTimeout pra próxima tick)
    setTimeout(() => URL.revokeObjectURL(objectUrl), 100);
    return true;
  } catch (err) {
    toast.error(errorMsg);
    return false;
  }
}
